import { Box } from '@mui/material';
import { SymbolLayout } from '../../widgets/layouts/symbol-layout';

import { OpenTradingFormButton } from '@client/widgets/trading-form/open-trading-form-button';
import { OpenFileDownloadFormButton } from '@client/widgets/trading-form/open-file-download-form-button';
import { TradingWorkspaceProvider } from '@client/features/trading-workspace/trading-workspace.provider';
import { useObservable } from '@client/foundation/shared/utils/observable.hook';
import { getWorkspaceFullscreen$ } from '@client/widgets/layouts/workspace-fullscreen.service';
import { WorkspaceFullscreenToggle } from '@client/widgets/layouts/workspace-fullscreen-toggle';

const BacktestingContent = () => {
  const workspaceFullscreen = useObservable(() => getWorkspaceFullscreen$());

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <WorkspaceFullscreenToggle />
      {!workspaceFullscreen && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.7,
            m: 1
          }}
        >
          <OpenTradingFormButton mode="BACKTESTING" />
          <OpenFileDownloadFormButton />
        </Box>
      )}
      <SymbolLayout />
    </Box>
  );
};

export const Backtesting = () => {
  return (
    <TradingWorkspaceProvider>
      <BacktestingContent />
    </TradingWorkspaceProvider>
  );
};
